<template>
    <div>
        <Loading :value="loading"></Loading>
        <!-- RACOURCIS -->
        <v-card>
            <v-card-title>
                <v-breadcrumbs icons divider="chevron_right">
                    <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled"> {{ item.text }}</v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-card-title>
        </v-card>
        <br/>

        <div>
            <!--Listes des missions-->
            <v-card>
                <v-card-text fluid grid-list-md>
                    <h3>LISTE DES RESSOURCES TECHNIQUES / MANOEUVRES</h3>
                    <!--FILTRER LA LISTE-->
                    <!--<v-layout row >-->
                        <!--<v-flex class="mb-2">-->
                            <!--<el-select @change="" v-model="" placeholder="Filtrer la liste">-->
                                <!--<el-option-->
                                        <!--v-for="item in comboEtatMiss"-->
                                        <!--:key="item.etat"-->
                                        <!--:label="item.label"-->
                                        <!--:value="item.etat">-->
                                <!--</el-option>-->
                            <!--</el-select>-->
                        <!--</v-flex>-->
                    <!--</v-layout>-->


                    <div class="text-xs-right">
                        <!--IMPRIMER LA LISTE-->
                        <!--<v-tooltip top v-if="droitAcces.imprime_listExc_miss" >-->
                            <!--<v-btn  slot="activator" color="green" :disabled="disabledBtnMiss" @click.stop="imprimeMissionExc(selectEtatMiss)" dark>-->
                                <!--Liste en Excel-->
                                <!--<v-icon right > print</v-icon>-->
                            <!--</v-btn>-->
                            <!--Imprimer la liste des missions-->
                        <!--</v-tooltip>-->

                        <!--<v-tooltip top  v-if="droitAcces.imprime_liste_mission">-->
                            <!--<v-btn slot="activator" color="orange" :disabled="disabledBtnMiss" @click.stop="imprimeMission(selectEtatMiss)" dark>-->
                                <!--Liste-->
                                <!--<v-icon right > print</v-icon>-->
                            <!--</v-btn>-->
                            <!--Imprimer la liste des missions-->
                        <!--</v-tooltip>-->

                         <v-tooltip top>
                            <v-btn
                                v-if="true"
                                slot="activator"
                                color="orange"
                                @click.stop="generateRapport()"
                                dark
                            >
                                Pointage
                                <v-icon right>add</v-icon>
                            </v-btn>Effectuer un pointage journalier
                            </v-tooltip>

                    </div>
                    <data-tables :data="listeOuvriers">
                        <el-table-column prop="nom" label="Nom" width="200" fixed="left" > </el-table-column>
                        <el-table-column prop="nbContrats" label="Nb CONTRAT(S)" width="240"></el-table-column>
                        <el-table-column prop="mntTotal" label="MONTANT TOTAL" align="center">
                            <template slot-scope="scope">
                                {{new Intl.NumberFormat().format(scope.row.mntTotal)}}
                            </template>
                        </el-table-column>

                        <el-table-column prop="mntTotalVerse" label="MONTANT PAYE" align="center">
                            <template slot-scope="scope">
                                {{new Intl.NumberFormat().format(scope.row.mntTotalVerse)}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="mntTotalRestant" label="MONTANT RESTANT" align="center">
                            <template slot-scope="scope">
                                {{new Intl.NumberFormat().format(scope.row.mntTotalRestant)}}
                            </template>
                        </el-table-column>

                        <el-table-column label="Action" align="center" fixed="right"  >
                            <template slot-scope="scope">
                                <v-tooltip top>
                                    <v-btn slot="activator" @click="showInfoOuvrier(scope.row)" fab dark small color="blue">
                                        <v-icon dark>list</v-icon>
                                    </v-btn>
                                    Détails...
                                </v-tooltip>
                            </template>
                        </el-table-column>
                    </data-tables>
                </v-card-text>
            </v-card>
        </div>



      <v-dialog
            v-model="dialogRapport" persistent
            max-width="92%">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Pointage journalier</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogRapport = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-container>
            <el-steps :active="active" align-center simple>
                <el-step title="Taches"   icon="el-icon-edit"></el-step>
               <el-step title="Date rapport"  icon="el-icon-edit"></el-step>
                <el-step title="Ouvrier/Manoeuvre"   icon="el-icon-edit"></el-step>
            </el-steps>

            <el-form id="formContrat"  label-position="top" ref="formContrat"  :model="formContrat" class="demo-ruleForm" >

                    <el-card class="box-card" v-if="active == 0">
                        <el-row type="flex" :gutter="20">
                                <el-col :span="9">
                                  <div class="block">
                                    <span class="demonstration">Projet concerné</span>
                                    <el-select
                                      filterable
                                      v-on:change="loadChantier()"
                                      v-model="formContrat.projet"
                                      placeholder="Type de Projet"
                                      style="width:100%"
                                    >
                                      <el-option
                                        v-for="item in listeProjet"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id"
                                      ></el-option>
                                    </el-select>
                                  </div>
                                </el-col>
                                <el-col :span="6">
                                  <div class="block">
                                    <span class="demonstration">Chantier concerné</span>
                                    <el-select
                                      filterable
                                      v-on:change="loadTravaux()"
                                      v-model="formContrat.chantier"
                                      placeholder="Chantier concerné"
                                      style="width:100%"
                                    >
                                      <el-option
                                        v-for="item in listeChantier"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id"
                                      ></el-option>
                                    </el-select>
                                  </div>

                                 </el-col>

                                <el-col :span="9">
                                  <div class="block">
                                    <span class="demonstration">Travaux</span>
                                    <el-select
                                      filterable
                                      v-on:change="loadTacheTrx()"
                                      v-model="formContrat.travaux"
                                      placeholder="Travaux"
                                      style="width:100%"
                                    >
                                      <el-option
                                        v-for="item in listeTravaux"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id"
                                      ></el-option>
                                    </el-select>
                                  </div>

                                 </el-col>

                              <!-- <el-col :span="6">
                                  <div class="block">
                                    <span class="demonstration">Tâches</span>
                                    <el-select
                                      filterable  multiple
                                      v-model="selectTaches"
                                      placeholder="Tâche"
                                      style="width:100%"
                                    >
                                      <el-option
                                        v-for="item in listeTacheTrx"
                                        :key="item.idOptTrx"
                                        :label="item.libelle"
                                        :value="item.idOptTrx"
                                      ></el-option>
                                    </el-select>
                                  </div>

                                 </el-col> -->
                        </el-row>
                    </el-card>

                <!--Date de rapport-->
                <el-card class="box-card" v-if="active == 1">
                    <el-row type="flex" :gutter="20">
                     <v-flex xs12>
                       <v-alert  class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                            Le pointage se fait uniquement sur les rapports journaliers effectués par le commis
                            </v-alert>
                          <v-layout row>
                             <v-flex  class="text-xs-center">
                            </v-flex>
                          <v-flex xs12 class="text-xs-center pr-2">
                              <v-card class="elevation-5 pl-2 pt-2">
                                <h4>
                                  Rapport non effectués
                                  <v-chip outline color="red">{{listeRptNon.length}}</v-chip>
                                </h4>
                                <v-divider class="mb-1"></v-divider>
                                <el-table v-if="listeRptNon.length != 0" :data="listeRptNon" height="325" style="width: 100%"  @selection-change="handleSelectionChange">
                                    <!-- <el-table-column :selectable="besoinSelect" width="55" type="selection"></el-table-column> -->
                                  <el-table-column prop="dateRpt" label="Date" width="180"></el-table-column>
                                  <el-table-column prop="travaux" label="Travaux"></el-table-column>
                                  <el-table-column prop="tache" label="Tache"></el-table-column>
                                  <el-table-column prop="comis" label="Commis"></el-table-column>
                                  <el-table-column label="ACTION" align="center"  fixed="right">
                                    <template slot-scope="scope">
                                      <v-tooltip top>                                          
                                          <v-btn
                                            slot="activator"
                                            @click.stop="
                                              showPointage(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="green"
                                          >
                                            <v-icon dark
                                              >folder_open</v-icon
                                            > </v-btn
                                          >Details du pointage
                                        </v-tooltip>  
                                        <v-tooltip bottom>
                                            <v-btn
                                            @click="rapportJour(scope.row)"
                                            slot="activator"
                                            color="orange"
                                            fab
                                            dark
                                            small
                                            >
                                            <v-icon>note_add</v-icon>
                                            </v-btn>Continuer
                                        </v-tooltip>
                                    </template>
                                  </el-table-column>
                                </el-table>
                              </v-card>
                            </v-flex>
                            <v-flex  class="text-xs-center">
                            </v-flex>
                          </v-layout>
                        </v-flex>
                    </el-row>
                </el-card>

                <!--Ouvrier-->
                <el-card class="box-card" v-if="active == 2">
                    <el-row type="flex" :gutter="20">
                       <ListePresence :idTravaux= formContrat.travaux :type="'pointage'" :listeOuvriers="listePrestOuvriers" @dataChange="loadListePresence"></ListePresence>
                    </el-row>
                </el-card>


                <el-row justify="end">
                    <el-col :span="24" >
                        <div class="text-xs-right" >
                            <v-btn
                                    v-if="active!=0"
                                    color="primary"
                                    @click="previous"
                            >

                                Précédent
                            </v-btn>

                            <v-btn
                                    v-if="active!=2 && active!=1 && formContrat.travaux"
                                    color="primary"
                                    @click="next"
                                    :disabled="isInvalide"
                            >
                                Suivant

                            </v-btn>


                            <v-btn
                                    v-if="active==2"
                                    dark
                                    color="green"
                                    @click="createRapport('formContrat')"
                            >

                                Enregistrer
                                <v-icon right dark>save</v-icon>
                            </v-btn>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogListRapport" transition="dialog-bottom-transition" scrollable max-width="90%" persistent>
    <v-flex xs12>
      <v-toolbar card dark color="primary">
          <v-toolbar-title>LISTE DES RESSOURCES TECHNIQUES UTILISÉ DANS LE RAPPORT DU {{dateRapport }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogListRapport = false"> <v-icon>close</v-icon> </v-btn>
      </v-toolbar>
      <v-card color class="mb-5">
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-card class="pt-2">
                <h4>LISTE DES RESSOURCES TECHNIQUES UTILISEES</h4>
                <v-divider></v-divider>
                <br />               
                <v-layout row>
                  <el-table
                    :data="detailRapport.listeParticipants"
                    style="width: 100%"
                  >
                    <el-table-column type="expand">
                          <template slot-scope="props">
                            <v-flex v-if=" props.row.heureSuppl != '00:00'">
                            <p>
                              <b>Heure supplémentaire</b>
                              : {{ props.row.heureSuppl }}
                            </p>
                            <p>
                              <b>Description heure supplémentaire</b>
                              : {{props.row.descriptionSupp}}
                            </p>
                            </v-flex>
                              <p>
                              <b>Description</b>
                              : {{ props.row.description }}
                            </p>
                          </template>
                    </el-table-column>
                    <el-table-column prop="nomPrenom" label="Nom & Prénoms" sortable></el-table-column>
                    <el-table-column prop="travaux" label="Travaux" sortable></el-table-column>
                    <el-table-column prop="heureDbt" label="Heure début" sortable></el-table-column>
                    <el-table-column prop="heureFin" label="Heure fin" sortable></el-table-column>
                    <el-table-column prop="heurePause" label="Heure pause" sortable></el-table-column>
                    <el-table-column prop="heureIntem" label="Heure Intemperie" sortable></el-table-column>
                    <el-table-column prop="heureTotal" label="Heure travail" sortable></el-table-column>
                  </el-table>
                </v-layout>

                <v-alert
                  v-if="detailRapport.listeParticipants &&
                    detailRapport.listeParticipants.length == 0
                  "
                  class="elevation-1 subheading mb-1"
                  color="warning"
                  :value="true"
                  icon="priority_high"
                  outline
                >
                  Informations non renseignées lors de
                  l'enregistrement du rapport
                </v-alert>
                
                <br />
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-dialog>

      <!--DIALOG INFO OUVRIER-->
      <infoOuvrier  :show="showInfo" :infoOuvrier="infoOuvr" @close="showInfo = false" ></infoOuvrier>
      <!--DIALOG INFO OUVRIER-->

    </div>
</template>

<script>
    import Loading from '@/components/Loading';
    import infoOuvrier from '@/components/ouvrier/infoOuvrier';
    import ListePresence from "@/components/boardTravaux/ListePresence";

    export default {
        name: "liste-ouvrier",
        components:{ Loading, infoOuvrier,ListePresence},
        data(){
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,
                racourcis: [
                    {path: '/listeOuvrier', text: 'Ouvrier'},
                ],

                formContrat:{

                },

                listeOuvriers: [],
                selectTaches: [],
                listePrestOuvriers: [],
                listeProjets: [],
                listeTacheTrx: [],
                listeTravaux: [],
                listeProjet: [],
                tablePresence:[],
                listeChantier: [],
                listeRptNon: [],
                infoRapport: [],
                showInfo: false,
                active:0,
                infoOuvr : {},
                nombreSelection: 0,
                multipleSelection:[],
                etat:false,


                loading: false,
                dialogRapport: false,
                dialogListRapport: false,
                dateRapport: '',
                detailRapport:[] 

            }
        },

        methods:{
            showPointage(row) {
              this.loading = true;
              this.dateRapport = row.dateRpt
              let url = this.domaine + "journal/" + row.id;
              this.$http.get(url).then(
                response => {
                  this.dialogListRapport = true
                  this.detailRapport = response.body.journal;
                  this.loading = false;
                },
                error => {
                  this.loading = false;
                  this.$message.error("Echec lors du chargement des Journaux");
                }
              );
            },
            loadListeOuvrier()
            {
                this.loading = true;
                let url = this.domaine + "ouvrier/index";
                this.$http.get(url).then(
                    response => {
                        this.listeOuvriers = response.body.ouvrier;
                        this.loading = false;
                    },
                    error => {
                        this.loading = false;
                        this.$message.error("Echec lors du chargement des RESSOURCES TECHNIQUES");
                    }
                );
            },
            besoinSelect(row, index) {
                  let etat = null;
                  if (parseInt(row.qte) != 0) {
                    etat = true;
                  } else {
                    etat = false;
                  }
                  return etat;
                  },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.nombreSelection = val;
            },
            rapportJour(rapport){
              this.next()
              this.infoRapport = rapport
            },
            loadOuvrierTravaux() {
              this.loadStatRapport()
                this.loading = true;
                // on recherche tous les ouvrier affecter par defaut au chantier ou au travaux
                let url = this.domaine + "ouvrier/travaux/" + this.formContrat.travaux ;

                this.$http.get(url).then(
                    response => {
                    this.listePrestOuvriers = response.body.ouvriers;
                    this.loading = false;
                    },
                    error => {
                    this.loading = false;
                    this.$message.error(
                        "Echec lors du chargement de la liste des ouvriers"
                    );
                    }
                );
            },
            next() {
               this.loadOuvrierTravaux()
                  if (this.active++ > 1) this.active = 1;

            },
            previous() {
                if (this.active-- < 0 ) this.active = 0;
                this.etat = false
            },
            showInfoOuvrier(item){
                this.showInfo = true;
                this.infoOuvr = item
            },
            generateRapport() {
              this.dialogRapport = true
              this.formContrat = {}
              this.selectTaches = []
            },
            loadProjet() {
                  let url = this.domaine + "projet/index/projet/all";

                  this.loading = true;
                  this.$http.get(url).then(
                    response => {
                      this.loading = false;
                      this.listeProjet = response.body.projet;
                    },
                    errRep => {
                      this.loading = false;
                      this.$message.error(
                        "Une erreur est survenue lors du chargement de la liste des projets"
                      );
                    }
                  );
            },
            loadChantier() {
              if (this.formContrat.projet == "" || this.formContrat.projet == null) {
                return;
              }
              this.loading = true;
              this.listeChantier.splice(0);
              this.listeTacheTrx.splice(0);
              this.listeTravaux.splice(0);

              let url = this.domaine + "projet/" + this.formContrat.projet + "/index/chantier";
              this.$http.get(url).then(
                response => {
                  this.loading = false;
                  this.listeChantier = response.body.chantier;
                },
                errRep => {
                  this.loading = false;
                  this.$message.error(
                    "Une erreur est survenue lors du chargement de la liste du chntier"
                  );
                }
              );
            },
            loadTravaux() {
              this.loading = true;
              // this.formContrat.travaux = "";
              this.listTravaux = [];
              if ( this.formContrat.chantier != "" && this.formContrat.chantier != null) {
                let url =
                  this.domaine + "projet/" + this.formContrat.chantier + "/index/chantier/travaux";
                this.$http.get(url).then(response => {
                  if (response.body) {
                    this.listeTravaux = response.body.travaux;
                    this.loading = false;
                  }
                });
              } else {
                this.$message.error("Veuillez sélectionner un chantier");
                this.loading = false;
              }
            },
            loadTacheTrx() {
                  this.loading = true;
                  this.listeTacheTrx.splice(0);
                  if (this.formContrat.travaux) {
                    let url = this.domaine + "tache/travaux/" + this.formContrat.travaux;
                    this.$http.get(url).then(response => {
                      this.listeTacheTrx = response.body.taches;
                      this.loading = false;
                    });
                  } else {
                    this.$message.error("Veuillez sélectionner une tache");
                    this.loading = false;
                  }
            },
            createRapport() {
                this.loading = true;
                let url = this.domaine + "journal/new/rapport/ouvrier";
                let data = new FormData()
                data.append("dateRapport", this.infoRapport.dateRptFormat);
                data.append("idUser", this.user.id);
                data.append("idTravaux", this.formContrat.travaux);
                data.append("tableRessourceOUvrier", JSON.stringify(this.tablePresence) )

                this.$http.post(url, data).then(
                      resp => {
                          this.loading = false;
                          this.$notify({
                              title: "Pointage effectué",
                              message: resp.body.message,
                              type: "success",
                              position: "top-right",
                              duration: 7000
                          });
                          this.dialogRapport = false
                          this.tableQuestion.splice(0);
                          this.tableTravaux.splice(0);
                          this.tableVisiteur.splice(0);
                          this.tableInventaire.splice(0);
                          this.tableRessource.splice(0);
                          this.tableRessTechnik.splice(0);
                          this.tablePresence.splice(0);

                          this.$emit("reloadListeTrx")
                          this.dialogAccord = false
                          this.closeDialog();

                      },
                      resp => {
                          this.loading = false;
                          this.$message.error(
                              "Erreur lors de l'enregistrement du journal"
                          );

                      }
                  );


            },
           loadStatRapport() {
            let url = this.domaine + "journal/stat/travaux/ouvrier";
            let data = new FormData();
            data.append("listeTrx", JSON.stringify(this.formContrat.travaux));
            this.$http.post(url, data).then(
              response => {
                this.loading = false;
                this.listeRptNon = response.body.listeTrxNonEffec;
              },
              error => {
                this.loading = false;
                this.$message.error("Erreur lors de dashboard travaux");
              }
            );
            },
           loadListePresence(liste){
                this.tablePresence = liste;
            },
        },
        computed:{
             isInvalide(){
                if(this.selectTaches) {
                     return false
                }
                else {
                    return true
                }
            }
        },

        mounted(){
            this.loadListeOuvrier()
            this.loadProjet()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ouvrier/listeOuvrier.vue